import {VmView} from 'components'
import {useRef} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {toCurrency} from 'utils/functions'

export const TextField = ({name, label, openModal, ...props}) => {
  const {control} = useFormContext()
  const inputRef = useRef(null) // Membuat ref untuk input
  const isNumberType = props?.type === 'number'
  isNumberType && delete props?.type

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.select() // Mengatur fokus pada input
    }
  }

  return (
    <VmView className="w-full mt-2">
      <label className="block text-gray-700 mb-1">{label}</label>
      <div className="flex w-full">
        <Controller
          name={name}
          control={control}
          render={({field, fieldState: {error}}) => (
            <div className="w-full">
              <input
                {...field}
                ref={inputRef} // Mengaitkan ref ke input
                type="text"
                value={isNumberType ? toCurrency(field.value) : field.value}
                onChange={e => {
                  const value = isNumberType
                    ? transformVmedisFormat(e.target.value)
                    : e.target.value
                  field.onChange(value)
                }}
                className="w-full p-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                onFocus={handleFocus}
                {...props}
              />
              {!!error && error?.message && (
                <p
                  style={{
                    fontSize: 14,
                    color: 'red',
                  }}
                >
                  {error?.message}
                </p>
              )}
            </div>
          )}
        />
        {name === 'obatetiketcatatan' && (
          <button
            type="button"
            onClick={openModal}
            className="ml-2 p-2 rounded-xl bg-gray-200 hover:bg-gray-300"
          >
            Cari
          </button>
        )}
      </div>
    </VmView>
  )
}

const transformVmedisFormat = value => value.replace(/[^0-9]/g, '')
